import AuthService from './AuthService';
import ApiService from './ApiService';

class OrdersService extends ApiService {
    constructor(authService) {
        super();

        this._authService = authService;
        this._locale = 'ru';
        this._headersUrl = '/orders/table-data';
        this._ordersUrl = '/orders';
        this._deleteUrl = '/orders/delete';
        this._updateUrl = '/orders/update';
    }

    getBaseHeaders() {
        const langHeader = this._locale ? { 'X-Localization': this._locale } : {};
        const authHeader = this._authService.getAuthHeader();

        return { ...authHeader, ...langHeader };
    }

    getHeaders() {
        return this.postResource(this._headersUrl, {}, this.getLangHeader());
    }

    getOrders(params) {
        return this.postResource(this._ordersUrl, params, this.getLangHeader());
    }

    getOrder(id) {
        return this.postResource(this._ordersUrl + '/' + id, {}, this.getLangHeader());
    }

    updateOrder(order) {
        return this.postResource(this._updateUrl, { order });
    }

    deleteOrder(id) {
        return this.postResource(this._deleteUrl, { id }, this.getBaseHeaders());
    }
}

const service = new OrdersService(AuthService);

export default service;
